import React from "react";

export default function expandMenuIcon({ color = "white", ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="15"
      viewBox="0 0 18 15"
      {...restProps}
    >
      <defs>
        <path id="a" d="M.712 0A.718.718 0 0 0 0 .713V2.14c0 .39.323.713.712.713h15.676a.718.718 0 0 0 .712-.713V.713A.718.718 0 0 0 16.388 0H.712zm0 5.705A.718.718 0 0 0 0 6.418v1.427c0 .39.323.713.712.713h15.676a.718.718 0 0 0 .712-.713V6.418a.718.718 0 0 0-.712-.713H.712zm0 5.706a.718.718 0 0 0-.712.713v1.427c0 .39.323.713.712.713h15.676a.718.718 0 0 0 .712-.713v-1.427a.718.718 0 0 0-.712-.713H.712z"/>
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a"/>
        </mask>
        <path fill={color} d="M-5 19.264h27.1V-5H-5z" mask="url(#b)"/>
      </g>
    </svg>
  );
}
